import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	helpText: {
		id: 'servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.help-text',
		defaultMessage: 'Group related articles in categories to help customers find what they need.',
		description: 'Help text to explain the value of categories to customers.',
	},
	nameFieldLabel: {
		id: 'servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.name-field-label',
		defaultMessage: 'Name',
		description: 'Label for the name field for the Create category form',
	},
	nameFieldPlaceholder: {
		id: 'servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.name-field-placeholder',
		defaultMessage: 'Category name, e.g "Printers" or "Wifi"',
		description: 'Placeholder for the name field for the Create category form',
	},
	descriptionFieldLabel: {
		id: 'servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.description-field-label',
		defaultMessage: 'Description',
		description: 'Label for the description field for the Create category form',
	},
	descriptionFieldPlaceholder: {
		id: 'servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.description-field-placeholder',
		defaultMessage: 'Tell customers more about this category',
		description: 'Placeholder for the description field for the Create category form',
	},
});
